<div class="separatorCenter">
    <h4>Copiar Acessos do Usuário - {{userSelected.name}}</h4>
</div>
<div class="content">
    <div class="tem-field">
        <label class="tem-field-label">Filtrar Usuários</label>
        <nz-input-group [nzPrefix]="searchIcon" [nzSuffix]="clearIcon">
            <input nz-input placeholder="Filtrar usuários" [(ngModel)]="userInputFilter" (keyup)="updateFilterUser()" />
        </nz-input-group>
        <ng-template #searchIcon><nz-icon nzType="search"></nz-icon></ng-template>
        <ng-template #clearIcon>
            <nz-icon *ngIf="userInputFilter" class="clear-icon" nzType="close-circle" nzTheme="fill" (click)="clearFilter()"></nz-icon>
        </ng-template>
    </div>
    <h5 class="lblUsuDest">Usuários Destino: <span class="dest-count" *ngIf="selectedUsers.size > 0">{{selectedUsers.size}} selecionado(s)</span></h5>
    <nz-spin class="dest-spin" [nzSpinning]="loadingDataUsers">
        <div class="dest-list">
            <label nz-checkbox *ngFor="let user of usersData"
                [ngModel]="selectedUsers.has(user.id)"
                (ngModelChange)="toggleUser(user, $event)">{{user.name}}</label>
        </div>
    </nz-spin>
</div>
<div class="finish">
    <button nz-button nzType="default" (click)="dialogRef.close(false)">Cancelar</button>
    <button nz-button nzType="primary" [disabled]="selectedUsers.size === 0" (click)="finalizar($event)">Copiar</button>
</div>
